import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "../../../../app/store";
import {SliceStatus} from "../../../BaseState";
import {DeleteUrlsModalState} from "./DeleteUrlsModalState";

const initialState: DeleteUrlsModalState = {
  isOpened: false,
  pendings: [],
  status: SliceStatus.idle,
  error: null
};

export const deleteUrlsModalSlice = createSlice({
  name: "deleteUrlsModal",
  initialState,
  reducers: {
    setIsOpened: (draft, action: PayloadAction<boolean>) => {
      draft.isOpened = action.payload;
    }
  }
});

export const deleteUrlsModalState = (state: RootState): DeleteUrlsModalState => state.deleteUrlsModal;
export const {setIsOpened} = deleteUrlsModalSlice.actions;
export default deleteUrlsModalSlice.reducer;
